import { updateCart } from '@/clients/storefront/cartService';
import Button, {
  type ButtonProps,
  ButtonSize,
} from '@/components/BaseLibrary/Button/Button';
import useSunrunShopStore, {
  useSunrunShopActions,
} from '@/data-store/hooks/useSunrunShopStore';
import { CartActions } from '@/data-store/slices/sunrunShopSlice';

function AddToCartButton({
  variantId,
  ...props
}: ButtonProps & {
  variantId: string | undefined;
}) {
  const { cartId, selectedQuantity } = useSunrunShopStore(
    'cartId',
    'selectedQuantity'
  );
  const { setCart, setCartId, setIsCartOpen, setCartAction } =
    useSunrunShopActions();

  const handleClick = async () => {
    if (!variantId) return;

    const newCart = await updateCart(cartId, {
      merchandiseId: variantId,
      quantity: selectedQuantity,
    });

    if (newCart) {
      const { cart, cartId: newCartId } = newCart;
      setCart(cart);
      setCartId(newCartId);
      setIsCartOpen(true);
      setCartAction(CartActions.ADD_ITEM);
    }
  };

  return (
    <Button
      {...props}
      disabled={!variantId}
      onClick={handleClick}
      size={{ xs: ButtonSize.SM, md: ButtonSize.MD }}
    />
  );
}

export default AddToCartButton;
